// Enum For WorkItemStatusIds
export enum WorkItemStatusIds {

	// Id for mark status as InProgress
	WORKITEM_INPROGRESS = "e80b543b-c3a8-4ea8-b70b-4aa378636063",

	// Id for mark status as completed
	WORKITEM_COMPLETED = "63473dbb-bd6e-4618-877b-d5fdd5023bdd"
}